<template>
	<div class="store-pop-up">
		<div class="store-pop-up__backdrop" ref="backdrop" @click.once="toggle()"></div>
		<div class="store-pop-up__inner wc" ref="modal_inner">
			<div class="store-pop-up__header" :class="{ isOffers: isOffers }">
				<div class="store-pop-up__x-btn pointer" @click.once="toggle()">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="22.75"
						height="22.75"
						viewBox="0 0 22.75 22.75"
					>
						<path
							id="Icon_metro-cancel"
							data-name="Icon metro-cancel"
							d="M28.768,9.64l-7.11,7.11-7.11-7.11-4.266,4.266,7.11,7.11-7.11,7.11,4.266,4.266,7.11-7.11,7.11,7.11,4.266-4.266-7.11-7.11,7.11-7.11Z"
							transform="translate(-10.283 -9.64)"
							fill="#f7f7f7"
						/>
					</svg>
				</div>
				<!-- <div class="store-pop-up__header--img" v-if="!isOffers">
					<picture>
						<source
							media="(max-width: 767px)"
							:srcset="_.get(store_data, 'cover_image[0].devices.mobile')"
						/>
						<source
							media="(max-width: 1023px)"
							:srcset="_.get(store_data, 'cover_image[0].devices.tablet')"
						/>
						<img :src="_.get(store_data, 'cover_image[0].devices.desktop')" alt />
					</picture>
				</div> -->

				<picture class="pictures">
					<source
						media="(max-width: 767px)"
						:srcset="_.get(store_data, 'popup_image[0].devices.mobile')"
					/>
					<source
						media="(max-width: 1023px)"
						:srcset="_.get(store_data, 'popup_image[0].devices.tablet')"
					/>
					<img :src="_.get(store_data, 'popup_image[0].devices.desktop')" alt />
				</picture>

				<div class="store-pop-up__header--overlay"></div>
				<div class="store-pop-up__header--logo-div" v-if="!isOffers">
					<img class="store-pop-up__header--logo-div__bg" src="@/assets/imgs/logo_div_bg.png" />
					<div class="store-pop-up__header--logo-wrapper">
						<img
							class="store-pop-up__header--logo obj_contain"
							:src="_.get(store_data, 'logo[0].url')"
							alt=""
						/>
					</div>
				</div>
			</div>
			<div class="store-pop-up__text-box flex">
				<div class="store-pop-up__text-box--left flex column">
					<h2 class="font-21 bold">{{ _.get(store_data, 'title') }}</h2>
					<div class="flex store-pop-up__text-box--tags wrap" v-if="!isOffers">
						<router-link
							class="font-16 medium f-light-blue underline store-pop-up__text-box--tag flex"
							v-for="(item, idx) in tags"
							:key="idx"
							target="_blank"
							:to="get_tag_link(item)"
						>
							<span class="font-16 medium underline"> {{ _.get(item, 'title') }}</span>
							<span class="font-16 medium f-gray">{{ idx == tags.length - 1 ? '' : ',' }}</span>
						</router-link>
					</div>
					<div class="store-pop-up__text-box--row flex">
						<div
							class="font-16 bold mr-30 f-light-gray2 pr-30 flex al-center floor"
							v-if="!isOffers"
						>
							{{ $fn.tr('სართული') + ': ' }}
							<span
								class="levels"
								:key="indx"
								v-for="(item, indx) in getFloor(_.get(store_data, 'floor'))"
							>
								&nbsp;
								{{
									_.get(item, 'title') +
										`${indx == getFloor(_.get(store_data, 'floor')).length - 1 ? '' : ','}`
								}}
							</span>
						</div>
						<a
              target="_blank"
              :href="_.get(store_data, 'url_360')"
              class=" mr-30 pr-30 flex al-center f-black"
            >
              <span class="font-16 pangram-extrabold uppercase"
                >{{ $fn.tr("გალერეა")
                }}<sup class="font-10 pangram-extrabold uppercase"
                  >360</sup
                ></span
              >
            </a>
						<div @click="goToLink" class="flex al-center pointer" v-if="!isOffers">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="12.666"
								height="12.438"
								viewBox="0 0 12.666 12.438"
							>
								<path
									id="Path_335"
									data-name="Path 335"
									d="M153.34,8.019l-4.86-4.772v0L151.784,0h0l4.86,4.772V0h4.5V12.438H148.48V8.019Z"
									transform="translate(-148.48)"
									fill="#e11f26"
								/>
							</svg>
							<span class="font-16 bold f-red uppercase ml-10">{{ $fn.tr('ვიზიტი') }}</span>
						</div>
					</div>
					<div
						class="store-pop-up__editor"
						v-html="_.get(store_data, 'description') || _.get(store_data, 'content')"
					></div>
				</div>
				<div class="store-pop-up__text-box--right pl-30 flex column">
					<!-- 
						:to="$store.getters['main/getSingleUrl'](visit_url)"

					 -->
					<div @click="goToLink" class="flex al-center pointer offers-visit" v-if="isOffers">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="12.666"
							height="12.438"
							viewBox="0 0 12.666 12.438"
						>
							<path
								id="Path_335"
								data-name="Path 335"
								d="M153.34,8.019l-4.86-4.772v0L151.784,0h0l4.86,4.772V0h4.5V12.438H148.48V8.019Z"
								transform="translate(-148.48)"
								fill="#e11f26"
							/>
						</svg>
						<span class="font-16 bold f-red uppercase ml-10">{{ $fn.tr('ვიზიტი') }}</span>
					</div>
					<div
						class="flex column mb-30"
						v-if="_.get(store_data, 'phone') || _.get(store_data, 'shop_phone')"
					>
						<span class="bold font-16 f-light-gray2">{{ $fn.tr('ტელეფონი') + ':' }}</span>
						<span class="medium font-16 f-light-gray2">{{
							_.get(store_data, 'phone') || _.get(store_data, 'shop_phone')
						}}</span>
					</div>
					<div class="flex column mb-30" v-if="!isOffers">
						<span class="bold font-16 f-light-gray2">{{ $fn.tr('სამუშაო საათები') + ':' }}</span>
						<div class="flex" v-if="_.get(store_data, 'working_hours[0].hrs[0]')">
							<span class="medium font-16 f-light-gray2">{{
								_.get(store_data, 'working_hours[0].hrs[0]') + '-'
							}}</span>
							<span class="medium font-16 f-light-gray2">{{
								_.get(store_data, 'working_hours[0].hrs[1]')
							}}</span>
						</div>
					</div>
					<div class="flex column">
						<span class="bold font-16 f-light-gray2">{{ $fn.tr('მისამართი') + ':' }}</span>
						<span
							class="medium font-16 f-light-gray2"
							v-html="
								_.get(
									this.$store.state.main.indx,
									`widgets.shops_contact_${this.$store.state.main.mallType}.address`
								) || _.get(store_data, 'alternate_address')
							"
							>{{
						}}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import resize_handler from '@/mixins/resize_handler';
export default {
	mixins: [resize_handler],
	props: ['isOffers'],
	data() {
		return {};
	},
	methods: {
		get_tag_link(item) {
			let final_url;
			if (item.pid == 0) {
				final_url = {
					path: '',
					query: { cat_id: item.id, item_type: 0, page: 1 },
				};
			} else {
				final_url = {
					path: '',
					query: { cat_id: item.pid, item_type: item.id, page: 1 },
				};
			}
			return final_url;
		},
		toggle() {
			let _timeout, TIMEOUT;
			this.$refs.modal_inner.classList.remove('active');

			TIMEOUT = setTimeout(() => {
				this.$refs.backdrop.classList.remove('active');
				clearTimeout(TIMEOUT);
			}, 500);
			_timeout = setTimeout(() => {
				this.$store.commit('main/setState', {
					key: 'store_pop_up',
					val: false,
				});
				clearTimeout(_timeout);
			}, 921);
		},
		goToLink() {
			if (this.isOffers) {
				this.$router?.push(
					this.$store.getters['main/getSingleUrl'](this.store_data?.relations_data?.stores?.[0])
				);
			}
			if (!this.isOffers) {
				this.$router?.push(
					this.$store.getters['main/getSingleUrl'](this.$store.state.main.store_pop_up)
				);
				return;
			}
			let shop_link;
			shop_link =
				this.$route.params.path1 === 'saburtalo'
					? this.$store.state.main.indx.menus.filter(
							(m) => m.configs.includes('shops') && m.configs.includes('search_main_type_saburtalo')
					  )
					: this.$store.state.main.indx.menus.filter(
							(m) => m.configs.includes('shops') && m.configs.includes('search_main_type_gldani')
					  );
			setTimeout(() => {
				this.$store.commit('main/setState', {
					key: 'store_pop_up',
					val: false,
				});
				document.body.classList.remove('ov_hidden');
				this.$router.push(
					shop_link[0].full_url + '/singleview/' + this.store_data.id + '-' + this.store_data.slug
				);
			}, 100);
		},
		getFloor(floorId) {
			const floorWidget = this.$store.state.main?.indx?.terms?.floors;
			const res = [];
			floorId?.length
				? floorId.forEach((floor) => {
						res.push(floorWidget.find((item) => item.id == floor));
				  })
				: '';
			return res;
		},
	},
	computed: {
		toggler() {
			return this.$store.state.main.store_pop_up;
		},
		store_data() {
			return this.$store.state.main.store_modal_data;
		},
		tags() {
			return this.$store.state.main.indx.terms.store_categories.filter((cat) =>
				this.store_data.store_categories?.includes(cat.id)
			);
		},
		visit_url() {
			return this.store_data?.relations_data?.stores?.[0];
		},
	},
	watch: {
		toggler: {
			immediate: true,
			handler(ns) {
				let _timeout, TIMEOUT;
				if (ns == true) {
					_timeout = setTimeout(() => {
						this.$refs.backdrop.classList?.add('active');
						clearTimeout(_timeout);
					}, 200);
					TIMEOUT = setTimeout(() => {
						this.$refs.modal_inner.classList?.add('active');
						clearTimeout(TIMEOUT);
					}, 400);
					if (this.windowWidth <= 767) {
						document.body.classList?.add('ov_hidden');
						document.getElementsByTagName('html')[0].removeAttribute('style');
					}
				} else {
					document.body.classList.remove('ov_hidden');
				}
			},
		},
	},
	mounted() {},
};
</script>

<style lang="scss">
.store-pop-up {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 9999999999999;
	&__backdrop {
		transition: 0.4s;
		@include modal_bg(#1a1a1a, 3);
		opacity: 0;
		&.active {
			opacity: 0.5;
		}
	}
	&__x-btn {
		position: absolute;
		top: 30px;
		right: 30px;
		width: 23px;
		height: 23px;
		z-index: 5;
		svg path {
			transition: 0.4s;
		}
		@include hover {
			svg path {
				fill: $red;
			}
		}
	}
	&__inner {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%) scale(0.6);
		background-color: white;
		z-index: 4;
		width: 1334px;
		opacity: 0;
		transition: 0.6s;
		&.active {
			transform: translate(-50%, -50%) scale(1);
			opacity: 1;
		}
	}
	&__text-box {
		padding-right: 100px;
		padding-left: 100px;
		padding-top: 65px;
		padding-bottom: 50px;

		&--left {
			border-right: 1px solid rgba(77, 77, 79, 0.1);
			padding-right: 100px;
			width: 932px;
		}
		&--tag {
			&:not(:last-child) {
				margin-right: 10px;
			}
			margin-bottom: 5px;
		}
		&--tags {
			width: 466px;
			margin-bottom: 11px;
			@media (max-width: 500px) {
				width: 100%;
			}
		}
		&--row {
			margin-bottom: 39px;
			a {
				transition: 0.4s;
				svg path,
				span {
					transition: 0.4s;
				}
				&:nth-child(2) {
					@include hover {
						span {
							color: $red;
						}
					}
				}
				&:nth-child(3) {
					@include hover {
						span {
							color: black;
						}
						svg path {
							fill: black;
						}
					}
				}
			}
			div,
			a {
				height: 30px;
			}
			.mr-30 {
				border-right: 1px solid rgba(77, 77, 79, 0.1);
			}
		}
		.floor {
			span {
				&.levels {
					margin-left: 5px;
				}
				&:last-child {
					i {
						display: none;
					}
				}
			}
		}
	}

	&__header {
		position: relative;
		width: 100%;
		// height: 233px;

		height: auto;
		padding-top: 22%;
		@media (max-width: 1023px) {
			padding-top: 32%;
		}
		&.isOffers {
			height: auto;
			padding-top: 22%;
			.pictures img {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}
		&--overlay {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			z-index: 2;
			height: 100%;
			background-image: linear-gradient(to bottom, #1a1a1a00, #1a1a1ab3);
		}

		&--img {
			position: relative;
			height: 100%;
			width: 100%;
			overflow: hidden;
			img {
				position: absolute;
				top: -20%;
				left: 0;
				width: 100%;
				min-height: calc(233px + 20%);
				object-fit: cover;
			}
		}
		.pictures img {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
		&--logo-wrapper {
			position: relative;
			margin-left: auto;
			margin-right: auto;
			width: 102px;
			height: 102px;
			margin-top: 48px;
		}
		&--logo {
			position: absolute;
			width: calc(100% - 34px);
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
		}
		&--logo-div {
			position: absolute;
			width: 119px;
			height: 157px;
			left: 100px;
			bottom: -31px;
			z-index: 3;
			&__bg {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
			}
		}
	}
	.offers-visit {
		margin-bottom: 15px;
	}

	@media (max-width: 1679px) {
		&__inner {
			width: 80%;
		}
		&__text-box {
			padding-left: 55px;
			padding-right: 55px;
			&--left {
				padding-right: 60px;
				width: 78%;
			}
		}
		&__header {
			&--logo-div {
				left: 55px;
			}
		}
	}
	@media (max-width: 1200px) {
		&__inner {
			width: 89%;
		}
		&__header {
			&--logo-div {
				left: 30px;
			}
		}
		&__editor {
			border-right: 1px solid rgba(77, 77, 79, 0.1);
			padding-right: 15px;
			padding-top: 43px;
			padding-bottom: 34px;
		}
		&__text-box {
			flex-direction: column;
			padding-left: 30px;
			padding-right: 30px;
			&--row {
				margin-bottom: 0;
			}
			&--left {
				padding-right: 0px;
				border-right: none;
			}
			&--right,
			&--left {
				width: 100%;
			}
			&--right {
				position: relative;
				padding-left: 0;
				padding-right: 58px;
				flex-direction: row;
				justify-content: space-between;
				// border-top: 1px solid rgba(77, 77, 79, 0.1);
				padding-top: 34px;
				border-right: 1px solid rgba(77, 77, 79, 0.1);
				&:after {
					content: '';
					position: absolute;
					top: 0;
					left: 0;
					height: 1px;
					width: calc(100% - 15px);
					background-color: rgba(77, 77, 79, 0.1);
				}
			}
		}
	}
	@media (max-width: 767px) {
		&__inner {
			width: 100%;
			height: 100%;
			overflow-x: hidden;
			overflow-y: auto;
		}
		&__header {
			&--logo-div {
				left: 16px;
			}
		}
		&__editor {
			border-right: none;
			padding-right: 0;
		}
		&__text-box {
			flex-direction: column;
			padding-left: 16px;
			padding-right: 16px;
			padding-bottom: 34px;
			&--row {
				margin-bottom: 0;
				flex-wrap: wrap;
			}
			&--left {
				padding-right: 0px;
				border-right: none;
			}
			&--right,
			&--left {
				width: 100%;
			}
			&--right {
				padding-right: 0;
				padding-top: 34px;
				border-right: none;
				flex-wrap: wrap;
				&:after {
					content: '';
					position: absolute;
					top: 0;
					left: 0;
					height: 1px;
					width: 100%;
					background-color: rgba(77, 77, 79, 0.1);
				}
			}
		}
	}
}
</style>

<style lang="scss" scoped>
.store-pop-up__editor::v-deep {
	p,
	span,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	strong {
		color: $lightGray2;
	}
}
</style>
